<template>
	<div>
		<form class="account_ajax account__form" @submit.prevent="sendReg">
			<transition name="fade">
				<div class="account__errors" v-if="errors">{{ errors }}</div>
			</transition>
			<input class="uk-input" name="role" type="hidden" value="standart">
			<input class="uk-input" name="curator_id" type="hidden" value="" v-model="metki.curator_id.value">
			<label class="uk-form-label" v-show="metki.name.show">
				<span>Ваше имя</span>
				<input class="uk-input" name="name" type="text" placeholder="Имя" v-model="metki.name.value">
			</label>
			<label class="uk-form-label" v-show="metki.email.show">
				<span>Ваш Email</span>
				<input class="uk-input" name="email" type="email" placeholder="Email" v-model="metki.email.value">
			</label>
			<label class="uk-form-label" v-show="metki.email.show" v-if="!metki.curator_id.value">
				<span>Email вашего куратора</span>
				<input class="uk-input" name="curator_email" type="email" placeholder="Email куратора" v-model="metki.curator_email.value">
			</label>
			<label class="uk-form-label" v-show="metki.organization.show">
				<span>Название организации</span>
				<input class="uk-input" name="property[organization]" type="text" placeholder="организация" v-model="metki.organization.value">
			</label>
			<label class="uk-form-label">
				<span>Ваш пароль</span>
				<input class="uk-input" name="password" type="password" placeholder="Пароль">
			</label>
			<label class="uk-form-label">
				<span>Подтверждение пароля</span>
				<input class="uk-input" name="password_confirmation" type="password" placeholder="Подтверждение пароля">
			</label>

			<div class="account__buttons">
				<button class="uk-button uk-button-primary" type="submit" :disabled="!$root.confid">Зарегистрироваться</button>
				<div class="confid">
					<label>
						<input type="checkbox" class="uk-checkbox" v-model="$root.confid" />
						<div class="confid__content">
							<span>Я согласен с</span><a uk-toggle="target: #politicamodal">политикой конфиденциальности</a></div>
					</label>
				</div>
			</div>
		</form>
		<wait></wait>
	</div>
</template>

<script>
  import { bus } from './bus.js'
  import { account } from "../mixins/account";
  import wait from './wait'
  export default {
    name: "account-register",
    mixins: [account],
    components: {wait},
    data() {
      return {
        metki: {
          curator_id: {
            value: '',
            show: true
          },
          email: {
            value: '',
            show: true
          },
          curator_email: {
            value: '',
            show: true
          },
          name: {
            value: '',
            show: true
          },
          organization: {
            value: '',
            show: true
          }
        }
      }
    },
    props: {},
    methods: {
      setParams(parts) {
        let metki = this.metki;

        for (let key in parts) {
          console.log(key, parts[key]);
          if (parts[key]) {
            metki[key].value = parts[key];
            metki[key].show = false;
          }
        }

      },
      sendReg() {bus.$emit('wait', true);
        let app = this;
        $('.account_ajax').request('Registration::onAjax', {
          success: function (data) {
            app.checkErrors(data);
            bus.$emit('wait', false);
          }
        });
      },

      /* РАБОТА С МЕТКАМИ */
      getUrlVars() {
        let vars = {};
        let parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
          vars[key] = decodeURIComponent(value);
        });

        return vars;
      },
      getMetki() {
        let parts = this.getUrlVars();
        let metki;

        if (Object.keys(parts).length == 0) {
          //console.log('меток нет, проверим в хранилище');
          console.log('Параметров нет');
          //this.metki = this.getMetkiFromStorage();
        } else {
          //console.log('метки есть, запишем их');
          //this.metki = parts;
          this.setParams(parts);
          //this.storageMetki(parts);
        }
      },
      storageMetki(obj) {
        console.log('Бережно сохраняем наши метки');
        var sObj = JSON.stringify(obj);
        localStorage.setItem("metki", sObj);
      },
      getMetkiFromStorage() {
        console.log('Проверяем, есть ли метки');
        return JSON.parse(localStorage.getItem("metki"))
      },
      objToString(obj) {
        var str = '';
        for (var p in obj) {
          if (obj.hasOwnProperty(p)) {
            str += p + ' : ' + obj[p] + ' | ';
          }
        }
        return str;
      }
    },
    mounted() {
      this.getMetki();
    }
  }
</script>



// WEBPACK FOOTER //
// themes/oprava/src/js/components/commerce/account-register.vue